import { useEffect } from "react";
import { navigate } from "@reach/router";
import { Button } from "newui/components/Button";
import SkeletonBase from "newui/components/Skeleton";
import { useAuthContext } from "newui/features/Auth/context/AuthContextProvider";
import { useRfxData } from "newui/features/Rfx/data-provider/RfxDataProvider";
import { RFX_TABS } from "utils/constants";
import { useEvaluation } from "../hooks/useEvaluation";
import { RFxEvaluationSteps } from "../components/RFxEvaluationSteps";

interface EvaluationPageProps {
	evaluationId?: string;
	path?: string;
}

export const EvaluationPage: React.FC<EvaluationPageProps> = () => {
	const { rfxData } = useRfxData();
	const rfxId = rfxData?.id;
	const { clientPaths } = useAuthContext();

	const { isLoading, evaluationState, fetchEvaluationState } = useEvaluation({
		rfxId,
	});

	useEffect(() => {
		fetchEvaluationState();
	}, [fetchEvaluationState]);

	const handleBack = (): void => {
		navigate(clientPaths.viewRfx(rfxData, RFX_TABS.EVALUATION));
	};

	if (isLoading) {
		return (
			<div className="space-y-3 p-6">
				<SkeletonBase
					startColor="lightgray"
					width="100%"
					height="48px"
					className="!rounded-lg"
				/>
				<SkeletonBase
					startColor="lightgray"
					width="60%"
					height="40px"
					className="!rounded-lg"
				/>
			</div>
		);
	}

	return (
		<div data-testid="evaluation-page" className="p-6">
			<div className="mb-4">
				<Button btntype="secondary" onClick={handleBack}>
					← Back to RFx
				</Button>
			</div>
			<div className="mb-6">
				<h1 className="text-2xl font-semibold text-gray-900">
					EvaluA<span className="text-utility-brand-700">I</span>tion tool
				</h1>
				<p className="mt-1 text-sm text-gray-500">
					Use AI-assisted evaluation to systematically score and compare supplier
					submissions.
				</p>
			</div>
			<RFxEvaluationSteps
				rfxId={rfxId}
				evaluationState={evaluationState}
				onComplete={handleBack}
			/>
		</div>
	);
};
